import { View } from "react-native";
import { usePathname } from "expo-router";
import { ReportNavCard } from "app/features/reporting/molecules/ReportNavCard";
import { REPORT_TYPE_MAP } from "app/constants/ReportTypeConstant";

export function ReportsListTemplate() {
  const pathName = usePathname();

  return (
    <View className="resident-container flex-column gap-3">
      {REPORT_TYPE_MAP.map(({ icon, tag, label }, index) => {
        const href = `${pathName}/${tag}`;
        return (
          <ReportNavCard key={index} icon={icon} label={label} href={href} />
        );
      })}
    </View>
  );
}
